// jQuery start
jQuery(function () {
  // Smooth scroll
  jQuery('a[href^="#"]').click(function () {
    var speed = 800;
    var href = jQuery(this).attr("href");
    var target = jQuery(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    jQuery("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "swing"
    );
    return false;
  }); //Smooth scroll END

  // loading
  // $(document).ready(function () {
  //   jQuery(".loading").addClass("active");
  // });

  $(window).on("load", function () {
    jQuery(".loading").addClass("active");
  });

  // scroll class add
  jQuery(window).on("load scroll resize", function () {
    var st = jQuery(window).scrollTop();
    var wh = jQuery(window).height();
    var ww = jQuery(window).width();

    // fast(<1) slow(>1)
    jQuery(".fade, .fadeMask, .fadeUp, .fadeIn").each(function (i) {
      var tg = jQuery(this).offset().top - wh * 0.9;
      if (st > tg) {
        jQuery(this).addClass("active");
      }
    });

    jQuery(".fade-up-fast").each(function (i) {
      var tg = jQuery(this).offset().top - wh * 0.8;
      if (st > tg) {
        jQuery(this).addClass("active");
      }
    });
  }); // scroll class add END

  // Click event humberger menu
  jQuery(".navBar").click(function () {
    jQuery(".l-header").toggleClass("active");
    jQuery(".navBar__line").toggleClass("active");
    jQuery(".header__body").toggleClass("active");
    jQuery(".header__snav").toggleClass("active");
  });

  jQuery(".header__snav__open__link").click(function () {
    jQuery(".l-header").removeClass("active");
    jQuery(".navBar__line").removeClass("active");
    jQuery(".header__body").removeClass("active");
    jQuery(".header__snav").removeClass("active");
  });
});
// jQuery End

// // scroll = class add
// window.onscroll = function () {
//   // go to top btn
//   var page_top = document.getElementById('pageTop');
//   if (window.pageYOffset > 800) {
//     page_top.classList.add("active");
//   } else {
//     page_top.classList.remove("active");
//   }
// }

// ====================================
// footerを下に固定
// ====================================
new (function () {
  var footerId = "footer";
  //メイン
  function footerFixed() {
    //ドキュメントの高さ
    var dh = document.getElementsByTagName("body")[0].clientHeight;
    //フッターのtopからの位置
    document.getElementById(footerId).style.top = "0px";
    var ft = document.getElementById(footerId).offsetTop;
    //フッターの高さ
    var fh = document.getElementById(footerId).offsetHeight;
    //ウィンドウの高さ
    if (window.innerHeight) {
      var wh = window.innerHeight;
    } else if (
      document.documentElement &&
      document.documentElement.clientHeight != 0
    ) {
      var wh = document.documentElement.clientHeight;
    }
    if (ft + fh < wh) {
      document.getElementById(footerId).style.position = "relative";
      document.getElementById(footerId).style.top = wh - fh - ft - 1 + "px";
    }
  }

  //文字サイズ
  function checkFontSize(func) {
    //判定要素の追加
    var e = document.createElement("div");
    var s = document.createTextNode("S");
    e.appendChild(s);
    e.style.visibility = "hidden";
    e.style.position = "absolute";
    e.style.top = "0";
    document.body.appendChild(e);
    var defHeight = e.offsetHeight;

    //判定関数
    function checkBoxSize() {
      if (defHeight != e.offsetHeight) {
        func();
        defHeight = e.offsetHeight;
      }
    }
    setInterval(checkBoxSize, 1000);
  }

  //イベントリスナー
  function addEvent(elm, listener, fn) {
    try {
      elm.addEventListener(listener, fn, false);
    } catch (e) {
      elm.attachEvent("on" + listener, fn);
    }
  }

  addEvent(window, "load", footerFixed);
  addEvent(window, "load", function () {
    checkFontSize(footerFixed);
  });
  addEvent(window, "resize", footerFixed);
})();

// ====================================
// 電話番号画像スマホ時にリンク
// ====================================
jQuery(function () {
  var ua = navigator.userAgent;
  if (ua.indexOf("iPhone") < 0 && ua.indexOf("Android") < 0) {
    jQuery(".telhref span").each(function () {
      jQuery(this).unwrap();
    });
  }
});

// ====================================
// オリジナルjs
// ====================================

// ====================================
// tab
// ====================================

$(function () {
  //tabをクリックしたときの動作
  $(".single-support__company__tab__item").click(function () {
    //クリックしたタブのindexを取得
    var index = $(".single-support__company__tab__item").index(this);

    $(".single-support__company__tab__contentsWrapper").removeClass("is-show");
    $(".single-support__company__secondaryTab__item").removeClass("is-active");
    $(".single-support__company__contents__table").removeClass("is-show");

    $(".single-support__company__tab__contentsWrapper")
      .eq(index)
      .addClass("is-show");
    $(".single-support__company__tab__contentsWrapper")
      .eq(index)
      .find(".single-support__company__secondaryTab__item:first-child")
      .addClass("is-active");
    $(".single-support__company__tab__contentsWrapper")
      .eq(index)
      .find(".single-support__company__contents__table:first-child")
      .addClass("is-show");

    $(".single-support__company__tab__item").removeClass("is-active");
    $(this).addClass("is-active");
  });

  //ページャーをクリックしたときの動作
  $(".single-support__company__secondaryTab__item").click(function () {
    //クリックしたページャーのindexを取得
    var index = $(".single-support__company__secondaryTab__item").index(this);

    $(".single-support__company__secondaryTab__item").removeClass("is-active");
    $(this).addClass("is-active");

    //テーブル操作
    $(".single-support__company__contents__table").removeClass("is-show");
    $(".single-support__company__contents__table")
      .eq(index)
      .addClass("is-show");
  });
});

// ====================================
// modal
// ====================================
$(function () {
  $(".single-kv__feature__txtBox__btn").on("click", function () {
    $(this).next(".single-kv__feature__modal").addClass("is-show").fadeIn();
  });

  $(".single-kv__feature__modal__close").on("click", function () {
    $(".single-kv__feature__modal").fadeOut();
    $(".single-kv__feature__modal").removeClass("is-show");
  });

  $(".single-kv__feature__modal").on("click", function () {
    $(".single-kv__feature__modal").fadeOut();
    $(".single-kv__feature__modal").removeClass("is-show");
  });
});
